import {graphql} from 'react-relay'

export const query = graphql`
  query ProjectsSidebarQuery {
    federationServers {
      ...projectTreesFederationServersFragment
    }
  }
`
